export default {
  data() {
    return {
      merchant: this.$store.state.merchant,
      tab: 0,
      request: this.$store.state.request,
      views: {
        analysis: false,
        more: false,
        schedule: false,
        payment: false,
        customer: false,
        repayment: false,
        eligibility: false,
        email: false,
        data: false
      }
    }
  },
  metaInfo() {
    return {
      title: 'Order details',
    }
  },
  created() {
    this.check();
  },
  methods: {
    check() {
      if (this.status > 2) return;
      if (!this.analysisDone) {
        this.showView('eligibility');
      }
    },
    reset() {
      this.closeViews();
      this.check();
    },
  },
  computed: {
    analysisDone() {
      return this.$store.getters["request/analysisDone"]
    },
    status() {
      return this.$store.getters['request/status']
    },
    emailVerified() {
      return this.$store.getters["request/emailVerified"]
    },
  }
}
